import { Component, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { TGEEProspectsChemicalsOtherService } from "./tgee-prospects-chemicals-other.service";

@Component({
    selector: 'GlobalHycoAwards',
    templateUrl:'./tgee-prospects-chemicals-other.component.html',
    styleUrls:['./tgee-prospects-chemicals-other.component.scss']
})

export class TGEEProspectsChemicalsOtherComponent {

    isLoadPanelVisible: boolean = false;
    tgeeProspectsChemicalsOtherData: any;
    readonly allowedPageSizes = [50, 100, 200];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, private tgeeProspectsChemicalsOtherService : TGEEProspectsChemicalsOtherService) {        
     this.getTGEEProspectsChemicalsReport();   
    }

    getTGEEProspectsChemicalsReport(){
        this.isLoadPanelVisible = true;
        this.tgeeProspectsChemicalsOtherService.getTGEEProspectsChemicalsReport().subscribe({
            next: tgeeProspectsChemicalsOtherDataList => {
                this.tgeeProspectsChemicalsOtherData = tgeeProspectsChemicalsOtherDataList;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching GlobalASUForecastReport data", error);
            }
        });
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    exportExcel(e) {        
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        this.dataGrid.instance.columnOption('productionFacilityId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TGEEProspectsChemicals.xlsx');
                });
        }).then(()=>{            
        this.dataGrid.instance.columnOption('siteId', 'visible', false);
        this.dataGrid.instance.columnOption('productionFacilityId', 'visible', false);        
        });
        e.cancel = true;
    }
}